import { getErrorData } from '@wix/members-area-commons-ts';
import type { PlatformControllerFlowAPI } from '@wix/yoshi-flow-editor';

import { RELOAD_ICON_SVG } from '../../../constants';
import type {
  ErrorHandler,
  SettingsPageErrorStateService,
  SettingsPageW,
  TFunction,
} from '../../../types';

export class ErrorStateService implements SettingsPageErrorStateService {
  t: TFunction;
  errorHandler: ErrorHandler;
  refreshPage: () => void;

  constructor(
    private readonly $w: SettingsPageW,
    flowAPI: PlatformControllerFlowAPI,
  ) {
    this.t = flowAPI.translations.t;
    this.errorHandler = flowAPI.errorHandler;

    this.refreshPage = () => {
      const { wixCodeApi } = flowAPI.controllerConfig;
      const url = wixCodeApi.location.url;
      wixCodeApi.location.to?.(url);
    };
  }

  setToPageLoadErrorContent(error: unknown) {
    const { message } = getErrorData(error, this.errorHandler.getResolvedError);

    this.$w('#text1').text = this.t('app.error-state.page-load.title');
    this.$w('#text2').text = message;

    this.resetHomeButton();
    this.$w('#homeButton').label = this.t('app.error-state.page-load.button');
    this.$w('#homeButton').icon = RELOAD_ICON_SVG;
    this.$w('#homeButton').onClick(this.refreshPage);
  }

  setToNotFoundContent() {
    this.$w('#text1').text = this.t('app.empty-state.not-found.title');
    this.$w('#text2').text = this.t('app.empty-state.not-found.description');

    this.resetHomeButton();
    this.$w('#homeButton').label = this.t('app.empty-state.not-found.button');
    this.$w('#homeButton').link = '/';
  }

  private resetHomeButton = () => {
    this.$w('#homeButton').icon = '';
    this.$w('#homeButton').link = '';
    // @ts-expect-error
    this.$w('#homeButton').removeEventHandler('onClick', this.refreshPage);
  };
}
